import { Controller } from "@hotwired/stimulus"

// Wires the analytics filter bar:
//   • Region chips: toggle btn-primary on the parent label as the underlying
//     checkbox flips, so users see immediate feedback before submitting.
//   • Date-range radios: auto-submit the form on change, since it's a single-
//     select and there's no reason to wait for the Apply button.
//   • If a "custom" date range is picked, the form does NOT auto-submit
//     so the user can fill in the date inputs first.
export default class extends Controller {
  connect() {
    this.element.addEventListener("change", this.handleChange)
  }

  disconnect() {
    this.element.removeEventListener("change", this.handleChange)
  }

  handleChange = (event) => {
    const input = event.target
    if (!(input instanceof HTMLInputElement)) return

    if (input.type === "checkbox" && input.name === "region_ids[]") {
      this.updateChipStyle(input)
      return
    }

    if (input.type === "radio" && input.name === "date_range") {
      this.updateChipStyle(input)
      // Auto-submit unless the user picked "custom" — let them fill the
      // date inputs first.
      if (input.value !== "custom") {
        this.element.requestSubmit()
      }
    }
  }

  updateChipStyle(input) {
    const label = input.closest("label")
    if (!label) return

    if (input.type === "radio") {
      // Single-select: clear primary on every radio's label, then set it on
      // the picked one.
      this.element
        .querySelectorAll(`input[type="radio"][name="${input.name}"]`)
        .forEach((radio) => {
          const radioLabel = radio.closest("label")
          if (!radioLabel) return
          radioLabel.classList.toggle("btn-primary", radio.checked)
          radioLabel.classList.toggle("btn-outline", !radio.checked)
        })
    } else {
      label.classList.toggle("btn-primary", input.checked)
      label.classList.toggle("btn-outline", !input.checked)
    }
  }
}
